module.exports = __webpack_public_path__ + "img/ic_word_send.f1c95b38.png";